import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@ami/react/core';

export default class CustomerApprovalApproveDocumentsModal extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    onShowUpdated: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
  };

  render() {
    const { show, onShowUpdated, onConfirm } = this.props;

    return (
      <Modal
        title="Confirm Approval"
        show={show}
        onShowUpdated={onShowUpdated}
        okTitle="Approve Documents"
        cancelTitle="Cancel"
        onOk={onConfirm}
        showCancel={true}
      >
        <p>Are you sure you want to approve these documents?</p>
      </Modal>
    );
  }
}
